import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-fill align-items-start" }
const _hoisted_2 = { class: "flex-column" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = /*#__PURE__*/_createVNode("small", null, "Vælg hvilke ændringer der skal udløse e-mail notifikationer.", -1)
const _hoisted_5 = { class: "form-check mt-2" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "onApplicationChanges"
}, " Send e-mail ved applikationsændringer ", -1)
const _hoisted_7 = { class: "form-check mt-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "onUserChanges"
}, " Send e-mail ved brugerændringer ", -1)
const _hoisted_9 = { class: "form-check mt-2" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "onRoleChanges"
}, " Send e-mail ved rolleændringer ", -1)
const _hoisted_11 = { class: "form-check mt-2" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "onRoleProfileChanges"
}, " Send e-mail ved rolleprofilændringer ", -1)
const _hoisted_13 = { class: "form-check mt-2" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "onOrganizationChanges"
}, " Send e-mail ved organisationsændringer ", -1)
const _hoisted_15 = { class: "form-check mt-2" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "onSystemChanges"
}, " Send e-mail ved systemændringer ", -1)
const _hoisted_17 = { class: "mt-5 p-5 bg-info flex-grow-1" }
const _hoisted_18 = { class: "d-flex mb-3 align-items-center" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "flex-column me-4" }, [
  /*#__PURE__*/_createVNode("h2", null, "Applikationer til bruger onboarding notifikationer"),
  /*#__PURE__*/_createVNode("small", null, "Vælg applikationer for at modtage notifikationer ved ny bruger onboarding. Flere valg tilladt")
], -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" + Tilføj applikation ")
const _hoisted_21 = { class: "d-flex justify-content-end" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Afbryd")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_error = _resolveComponent("error")!
  const _component_Column = _resolveComponent("Column")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ApplicationsPicker = _resolveComponent("ApplicationsPicker")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    draggable: false,
    modal: true,
    dismissableMask: true,
    visible: _ctx.isVisible,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h5", _hoisted_3, " Notifikationsliste - " + _toDisplayString(_ctx.notificationEmail.emailAddress), 1),
          _hoisted_4
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_21, [
        _createVNode(_component_Button, {
          onClick: _ctx.hide,
          class: "link me-2"
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_5, [
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.notificationEmail.notificationOptions.onApplicationChanges = $event)),
          onChange: _cache[2] || (_cache[2] = ($event: any) => (
          _ctx.onUpdateEmailNotificationOptions(
            _ctx.settingItemTypeEnum.UpdateApplicationChangesNotificationList,
            _ctx.notificationEmail.notificationOptions.onApplicationChanges
          )
        )),
          class: "form-check-input",
          type: "checkbox",
          id: "onApplicationChanges"
        }, null, 544), [
          [_vModelCheckbox, _ctx.notificationEmail.notificationOptions.onApplicationChanges]
        ]),
        _hoisted_6
      ]),
      _createVNode("div", _hoisted_7, [
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.notificationEmail.notificationOptions.onUserChanges = $event)),
          onChange: _cache[4] || (_cache[4] = ($event: any) => (
          _ctx.onUpdateEmailNotificationOptions(
            _ctx.settingItemTypeEnum.UpdateUserChangesNotificationList,
            _ctx.notificationEmail.notificationOptions.onUserChanges
          )
        )),
          class: "form-check-input",
          type: "checkbox",
          id: "onUserChanges"
        }, null, 544), [
          [_vModelCheckbox, _ctx.notificationEmail.notificationOptions.onUserChanges]
        ]),
        _hoisted_8
      ]),
      _createVNode("div", _hoisted_9, [
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.notificationEmail.notificationOptions.onRoleChanges = $event)),
          onChange: _cache[6] || (_cache[6] = ($event: any) => (
          _ctx.onUpdateEmailNotificationOptions(
            _ctx.settingItemTypeEnum.UpdateRoleChangesNotificationList,
            _ctx.notificationEmail.notificationOptions.onRoleChanges
          )
        )),
          class: "form-check-input",
          type: "checkbox",
          id: "onRoleChanges"
        }, null, 544), [
          [_vModelCheckbox, _ctx.notificationEmail.notificationOptions.onRoleChanges]
        ]),
        _hoisted_10
      ]),
      _createVNode("div", _hoisted_11, [
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.notificationEmail.notificationOptions.onRoleProfileChanges = $event)),
          onChange: _cache[8] || (_cache[8] = ($event: any) => (
          _ctx.onUpdateEmailNotificationOptions(
            _ctx.settingItemTypeEnum.UpdateRoleProfileChangesNotificationList,
            _ctx.notificationEmail.notificationOptions.onRoleProfileChanges
          )
        )),
          class: "form-check-input",
          type: "checkbox",
          id: "onRoleProfileChanges"
        }, null, 544), [
          [_vModelCheckbox, _ctx.notificationEmail.notificationOptions.onRoleProfileChanges]
        ]),
        _hoisted_12
      ]),
      _createVNode("div", _hoisted_13, [
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.notificationEmail.notificationOptions.onOrganizationChanges = $event)),
          onChange: _cache[10] || (_cache[10] = ($event: any) => (
          _ctx.onUpdateEmailNotificationOptions(
            _ctx.settingItemTypeEnum.UpdateOrganizationChangesNotificationList,
            _ctx.notificationEmail.notificationOptions.onOrganizationChanges
          )
        )),
          class: "form-check-input",
          type: "checkbox",
          id: "onOrganizationChanges"
        }, null, 544), [
          [_vModelCheckbox, _ctx.notificationEmail.notificationOptions.onOrganizationChanges]
        ]),
        _hoisted_14
      ]),
      _createVNode("div", _hoisted_15, [
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.notificationEmail.notificationOptions.onSystemChanges = $event)),
          onChange: _cache[12] || (_cache[12] = ($event: any) => (
          _ctx.onUpdateEmailNotificationOptions(
            _ctx.settingItemTypeEnum.UpdateSystemChangesNotificationList,
            _ctx.notificationEmail.notificationOptions.onSystemChanges
          )
        )),
          class: "form-check-input",
          type: "checkbox",
          id: "onSystemChanges"
        }, null, 544), [
          [_vModelCheckbox, _ctx.notificationEmail.notificationOptions.onSystemChanges]
        ]),
        _hoisted_16
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_Button, {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.applicationsPicker?.toggle($event))),
            class: "ms-auto secondary text-nowrap"
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_DataTable, {
          stripedRows: true,
          responsiveLayout: "scroll",
          value: _ctx.selectedApplications ?? [],
          selectionMode: "single"
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_error, { error: {
              title: 'Ingen applikationer valgt',
              message:
                'Ingen applikationer valgt. Du vil ikke modtage onboarding notifikationer, før du vælger mindst én.',
            } }, null, 8, ["error"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, { field: "name" }, {
              body: _withCtx(({ data }) => [
                _createVNode("span", null, _toDisplayString(data.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              style: {"width":"1px","white-space":"nowrap"},
              field: "menu"
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_Button, {
                  class: "danger inverted",
                  onClick: ($event: any) => (_ctx.onRemoveApplication(data))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'minus'] })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_ApplicationsPicker, {
          ref: "applicationsPicker",
          isApplicationOptionsLoading: _ctx.isApplicationOptionsLoading,
          applicationOptions: _ctx.applicationOptions,
          selectedApplications: _ctx.selectedApplications,
          onAddedApplication: _ctx.onAddedApplication
        }, null, 8, ["isApplicationOptionsLoading", "applicationOptions", "selectedApplications", "onAddedApplication"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}